import { useEffect, useMemo, useState } from "react"
import { useLocation, Link, useHistory } from 'react-router-dom'
import { Button, Table, Select, Input, InputNumber, message } from 'antd'
import _ from 'lodash'
import BreadCrumb from '../../component/BreadCrumb'
import { axiosTable, baseAxiosNoInfo } from "../../tool/axios"
import getPermission from '../../js/permission'
import './FoodPurchaseEdit.css'

const { Column } = Table
const { Option } = Select

let customerOrderList: any = {
    food_item_id: undefined,
    food_item_code: undefined,
    food_item_name: undefined,
    food_item_count: undefined,
    use_dosage: undefined,
    use_unit: undefined,
    buy_dosage: undefined,
    buy_unit: undefined,
    order_unit: undefined,
    escort_unit: undefined,
    total_unit: undefined,
    remark: undefined,
    escort_num: null,
    food_type_id: "",
    food_type_name: "",
    order_num: null,
    price: null,
    total_num: null,
    use_count: 40
}

let employeeOrderList: any = {
    food_item_id: undefined,
    food_item_code: undefined,
    food_item_name: undefined,
    order_num: undefined,
    order_unit: undefined,
    total_num: undefined,
    total_unit: undefined,
    remark: undefined,
}

let seasoningOrderList: any = {
    food_item_id: undefined,
    food_item_code: undefined,
    food_item_name: undefined,
    order_num: undefined,
    order_unit: undefined,
    total_num: undefined,
    total_unit: undefined,
    remark: undefined
}

let dailyItemOrderList: any = {
    food_item_id: undefined,
    food_item_code: undefined,
    food_item_name: undefined,
    order_num: undefined,
    order_unit: undefined,
    total_num: undefined,
    total_unit: undefined,
    remark: undefined
}

let otherDeptOrderList: any = {
    food_item_id: undefined,
    food_item_code: undefined,
    food_item_name: undefined,
    order_num: undefined,
    order_unit: undefined,
    total_num: undefined,
    total_unit: undefined,
    remark: undefined
}

export default function () {
    // 权限设置
    const permission: string[] = useMemo(() => {
        console.log(getPermission()) 
        return getPermission()
    }, [window.location.pathname])

    // 页面传递参数接收
    const Location: any = useLocation()
    const History: any = useHistory()

    // 采购单详情信息
    const [orderDetail, setOrderDetail] = useState<any>({})
    // 客餐食材
    const [customerFoodList, setCustomerFoodList] = useState<any>([{ ...customerOrderList }])
    // 员工餐食材
    const [employeeFoodList, setEmployeeFoodList] = useState<any>([{ ...employeeOrderList }])
    // 调料品
    const [seasoningList, setSeasoningList] = useState<any>([{ ...seasoningOrderList }])
    // 日用品
    const [dailyItemList, setDailyItemList] = useState<any>([{ ...dailyItemOrderList }])
    // 其它部门食材
    const [otherDeptFoodList, setOtherDeptFoodList] = useState<any>([{ ...otherDeptOrderList }])

    // 食材菜品列表
    const [foodItemList, setFoodItemList] = useState([])

    // 每日客餐-餐单详情
    const fetchDetail = () => {
        axiosTable('/cooking/order_list/detail', {
            params: {
                order_id: Location.state.order_id
            }
        }).then((res: any) => {
            const { customer_order_code, customer_order_date, store_name, customer_food_list } = res
            setOrderDetail({
                customer_order_code,
                customer_order_date,
                store_name
            })
            if(customer_food_list && customer_food_list.length) {
                customer_food_list.forEach((el:any) => {
                    let orderNum:any = el['order_num'] ? el['order_num'] : 0
                    let escortNum:any = el['escort_num'] ? el['escort_num'] : 0
                    let totalNum: any = Number(Number(orderNum) + Number(escortNum))
                    el['total_num'] = totalNum
                })
                setCustomerFoodList(customer_food_list)
            }
        })
    }

    // 根据菜品类型获取菜品列表
    const fetchFoodItemList = () => {
        baseAxiosNoInfo('/cooking/global/food_item_list', {
            params: {
                food_type_id: ''
            }
        }).then((res: any) => {
            setFoodItemList(res)
        })
    } 

    // 添加客餐物料
    const addCustomerFood = (type:any) => {
        if(type == 1) {
            let newCustomerFoodList: any = _.cloneDeep(customerFoodList)
            newCustomerFoodList.push({
                ...customerOrderList
            })
            setCustomerFoodList(newCustomerFoodList)

        } else if(type == 2) {
            let newEmployeeFoodList: any = _.cloneDeep(employeeFoodList)
            newEmployeeFoodList.push({
                ...employeeOrderList
            })
            setEmployeeFoodList(newEmployeeFoodList)

        } else if(type == 3) {
            let newSeasoningList: any = _.cloneDeep(seasoningList)
            newSeasoningList.push({
                ...seasoningOrderList
            })
            setSeasoningList(newSeasoningList)

        } else if(type == 4) {
            let newDailyItemList: any = _.cloneDeep(dailyItemList)
            newDailyItemList.push({
                ...dailyItemOrderList
            })
            setDailyItemList(newDailyItemList)

        } else {
            let newOtherDeptFoodList: any = _.cloneDeep(otherDeptFoodList)
            newOtherDeptFoodList.push({
                ...otherDeptOrderList
            })
            setOtherDeptFoodList(newOtherDeptFoodList)
        }
    }

    useEffect(() => {
        fetchFoodItemList()
        fetchDetail()
    }, [])

    // 金额输入框小数点控制后两位
    const limitDecimals = (value:any) => {
        // return value.replace(/[^0-9]/g, '')
        return value
    }

    // 选择食材项
    const  handleSelectFoodItem = (type:any, val: any, index: any) => {
        let newFoodItemList = _.cloneDeep(foodItemList)
        if(type == 1) {
            let newCustomerFoodList = _.cloneDeep(customerFoodList)
            let resultItem:any = newFoodItemList.find((el:any) => el.food_item_id == val)
            newCustomerFoodList.forEach((newCusItem:any, newCusIdx: any) => {
                if(newCusIdx == index) {
                    newCusItem['food_item_id'] = val
                    newCusItem['food_item_code'] = resultItem['food_item_code']
                    newCusItem['buy_unit'] = resultItem['buy_unit']
                    newCusItem['use_unit'] = resultItem['use_unit']
                    newCusItem['escort_unit'] = resultItem['buy_unit']
                    newCusItem['order_unit'] = resultItem['buy_unit']
                    newCusItem['total_unit'] = resultItem['buy_unit']
                }
            })
            setCustomerFoodList(newCustomerFoodList)

        } else if(type == 2) {
            let newEmployeeFoodList = _.cloneDeep(employeeFoodList)
            let resultItem:any = newFoodItemList.find((el:any) => el.food_item_id == val)
            newEmployeeFoodList.forEach((newCusItem:any, newCusIdx: any) => {
                if(newCusIdx == index) {
                    newCusItem['food_item_id'] = val
                    newCusItem['food_item_code'] = resultItem['food_item_code']
                    newCusItem['order_unit'] = resultItem['buy_unit']
                    newCusItem['total_unit'] = resultItem['buy_unit']
                }
            })
            setEmployeeFoodList(newEmployeeFoodList)

        } else if(type == 3) {
            let newSeasoningList = _.cloneDeep(seasoningList)
            let resultItem:any = newFoodItemList.find((el:any) => el.food_item_id == val)
            newSeasoningList.forEach((newCusItem:any, newCusIdx: any) => {
                if(newCusIdx == index) {
                    newCusItem['food_item_id'] = val
                    newCusItem['food_item_code'] = resultItem['food_item_code']
                    newCusItem['order_unit'] = resultItem['buy_unit']
                    newCusItem['total_unit'] = resultItem['buy_unit']
                }
            })
            setSeasoningList(newSeasoningList)

        } else if(type == 4) {
            let newDailyItemList = _.cloneDeep(dailyItemList)
            let resultItem:any = newFoodItemList.find((el:any) => el.food_item_id == val)
            newDailyItemList.forEach((newCusItem:any, newCusIdx: any) => {
                if(newCusIdx == index) {
                    newCusItem['food_item_id'] = val
                    newCusItem['food_item_code'] = resultItem['food_item_code']
                    newCusItem['order_unit'] = resultItem['buy_unit']
                    newCusItem['total_unit'] = resultItem['buy_unit']
                }
            })
            setDailyItemList(newDailyItemList)

        } else {
            let newOtherDeptFoodList = _.cloneDeep(otherDeptFoodList)
            let resultItem:any = newFoodItemList.find((el:any) => el.food_item_id == val)
            newOtherDeptFoodList.forEach((newCusItem:any, newCusIdx: any) => {
                if(newCusIdx == index) {
                    newCusItem['food_item_id'] = val
                    newCusItem['food_item_code'] = resultItem['food_item_code']
                    newCusItem['order_unit'] = resultItem['buy_unit']
                    newCusItem['total_unit'] = resultItem['buy_unit']
                }
            })
            setOtherDeptFoodList(newOtherDeptFoodList)
        }
    }

    // 客餐下单量
    const orderNumChange = (type:any, index: any, value: any, key:any) => {
        if(type == 1) {
            let newCustomerFoodList = _.cloneDeep(customerFoodList)
            newCustomerFoodList.forEach((el:any, idx:any) => {
                if(idx == index) {
                    el[key] = value
                    let orderNum:any = el['order_num'] ? el['order_num'] : 0
                    let escortNum:any = el['escort_num'] ? el['escort_num'] : 0
                    let totalNum: any = Number(Number(orderNum) + Number(escortNum))
                    el['total_num'] = totalNum
                }
            })
            setCustomerFoodList(newCustomerFoodList)

        } else if(type == 2) {
            let newEmployeeFoodList = _.cloneDeep(employeeFoodList)
            newEmployeeFoodList.forEach((el:any, idx:any) => {
                if(idx == index) {
                    el[key] = value
                    let orderNum:any = el['order_num'] ? el['order_num'] : 0
                    el['total_num'] = Number(orderNum)
                }
            })
            setEmployeeFoodList(newEmployeeFoodList)

        } else if(type == 3) {
            let newSeasoningList = _.cloneDeep(seasoningList)
            newSeasoningList.forEach((el:any, idx:any) => {
                if(idx == index) {
                    el[key] = value
                    let orderNum:any = el['order_num'] ? el['order_num'] : 0
                    el['total_num'] = Number(orderNum)
                }
            })
            setSeasoningList(newSeasoningList)

        } else if(type == 4) {
            let newDailyItemList = _.cloneDeep(dailyItemList)
            newDailyItemList.forEach((el:any, idx:any) => {
                if(idx == index) {
                    el[key] = value
                    let orderNum:any = el['order_num'] ? el['order_num'] : 0
                    el['total_num'] = Number(orderNum)
                }
            })
            setDailyItemList(newDailyItemList)

        } else {
            let newOtherDeptFoodList = _.cloneDeep(otherDeptFoodList)
            newOtherDeptFoodList.forEach((el:any, idx:any) => {
                if(idx == index) {
                    el[key] = value
                    let orderNum:any = el['order_num'] ? el['order_num'] : 0
                    el['total_num'] = Number(orderNum)
                }
            })
            setOtherDeptFoodList(newOtherDeptFoodList)
        }
    }

    // 客餐备注
    const orderRemarkChange = (type:any, index: any, value: any, key:any) => {
        if(type == 1) {
            let newCustomerFoodList = _.cloneDeep(customerFoodList)
            newCustomerFoodList.forEach((el:any, idx:any) => {
                if(idx == index) {
                    el[key] = value
                    let customerRemark:any = el['remark'] ? el['remark'] : ''
                    el['remark'] = customerRemark.target.value
                }
            })
            setCustomerFoodList(newCustomerFoodList)

        } else if(type == 2) {
            let newEmployeeFoodList = _.cloneDeep(employeeFoodList)
            newEmployeeFoodList.forEach((el:any, idx:any) => {
                if(idx == index) {
                    el[key] = value
                    let employeeRemark:any = el['remark'] ? el['remark'] : ''
                    el['remark'] = employeeRemark.target.value
                }
            })
            setEmployeeFoodList(newEmployeeFoodList)

        } else if(type == 3) {
            let newSeasoningList = _.cloneDeep(seasoningList)
            newSeasoningList.forEach((el:any, idx:any) => {
                if(idx == index) {
                    el[key] = value
                    let employeeRemark:any = el['remark'] ? el['remark'] : ''
                    el['remark'] = employeeRemark.target.value
                }
            })
            setSeasoningList(newSeasoningList)

        } else if(type == 4) {
            let newDailyItemList = _.cloneDeep(dailyItemList)
            newDailyItemList.forEach((el:any, idx:any) => {
                if(idx == index) {
                    el[key] = value
                    let employeeRemark:any = el['remark'] ? el['remark'] : ''
                    el['remark'] = employeeRemark.target.value
                }
            })
            setDailyItemList(newDailyItemList)

        } else {
            let newOtherDeptFoodList = _.cloneDeep(otherDeptFoodList)
            newOtherDeptFoodList.forEach((el:any, idx:any) => {
                if(idx == index) {
                    el[key] = value
                    let employeeRemark:any = el['remark'] ? el['remark'] : ''
                    el['remark'] = employeeRemark.target.value
                }
            })
            setOtherDeptFoodList(newOtherDeptFoodList)
        }
    }

    // 删除餐单选项
    const onDeledItem = (type:any, index:any) => {
        if(type == 1) {
            let newCustomerFoodList = _.cloneDeep(customerFoodList)
            if(newCustomerFoodList.length > 1) {
                newCustomerFoodList = newCustomerFoodList.filter((newCusItem: any, newCusIdx: any) => newCusIdx != index)
                setCustomerFoodList(newCustomerFoodList)
            }

        } else if(type == 2) {
            let newEmployeeFoodList = _.cloneDeep(employeeFoodList)
            if(newEmployeeFoodList.length > 1) {
                newEmployeeFoodList = newEmployeeFoodList.filter((newCusItem: any, newCusIdx: any) => newCusIdx != index)
                setEmployeeFoodList(newEmployeeFoodList)
            }

        } else if(type == 3) {
            let newSeasoningList = _.cloneDeep(seasoningList)
            if(newSeasoningList.length > 1) {
                newSeasoningList = newSeasoningList.filter((newCusItem: any, newCusIdx: any) => newCusIdx != index)
                setSeasoningList(newSeasoningList)
            }

        } else if(type == 4) {
            let newDailyItemList = _.cloneDeep(dailyItemList)
            if(newDailyItemList.length > 1) {
                newDailyItemList = newDailyItemList.filter((newCusItem: any, newCusIdx: any) => newCusIdx != index)
                setDailyItemList(newDailyItemList)
            }
            
        } else {
            let newOtherDeptFoodList = _.cloneDeep(otherDeptFoodList)
            if(newOtherDeptFoodList.length > 1) {
                newOtherDeptFoodList = newOtherDeptFoodList.filter((newCusItem: any, newCusIdx: any) => newCusIdx != index)
                setOtherDeptFoodList(newOtherDeptFoodList)
            }
        }
    }

    // 提交数据
    const onSave = () => {
        let customer_food_list: any = []
        customerFoodList.forEach((cusItem: any) => {
            const { food_item_id, food_item_count, use_dosage, buy_dosage, order_num, escort_num, total_num, remark } = cusItem
            if( cusItem.food_item_id && cusItem.total_num > 0 ) {
                customer_food_list.push({
                    food_item_id,
                    food_item_count,
                    use_dosage, 
                    buy_dosage, 
                    order_num, 
                    escort_num, 
                    total_num, 
                    remark
                })
            }
        })
        
        let employee_food_list: any = []
        employeeFoodList.forEach((empItem: any) => {
            const { food_item_id, order_num, total_num, remark } = empItem
            if( empItem.food_item_id && empItem.total_num > 0 ) {
                employee_food_list.push({
                    food_item_id,
                    order_num,
                    total_num, 
                    remark
                })
            }
        })

        let seasoning_list: any = []
        seasoningList.forEach((seaItem: any) => {
            const { food_item_id, order_num, total_num, remark } = seaItem
            if( seaItem.food_item_id && seaItem.total_num > 0 ) {
                seasoning_list.push({
                    food_item_id,
                    order_num,
                    total_num, 
                    remark
                })
            }
        })

        let daily_item_list: any = []
        dailyItemList.forEach((dailyItem: any) => {
            const { food_item_id, order_num, total_num, remark } = dailyItem
            if( dailyItem.food_item_id && dailyItem.total_num > 0 ) {
                daily_item_list.push({
                    food_item_id,
                    order_num,
                    total_num, 
                    remark
                })
            }
        })

        let other_dept_food_list: any = []
        otherDeptFoodList.forEach((otherItem: any) => {
            const { food_item_id, order_num, total_num, remark } = otherItem
            if( otherItem.food_item_id && otherItem.total_num > 0 ) {
                other_dept_food_list.push({
                    food_item_id,
                    order_num,
                    total_num, 
                    remark
                })
            }
        })

        if( !customer_food_list.length && !employee_food_list.legnth && !seasoning_list.length && !daily_item_list.length && !other_dept_food_list.length ) {
            return message.error('请填写采购单物料数据')
        }

        console.log(customer_food_list)
        console.log(employee_food_list)
        console.log(seasoning_list)
        console.log(daily_item_list)
        console.log(other_dept_food_list)

        baseAxiosNoInfo.post('/cooking/purchase/add', {
            order_id: Location.state.order_id,
            customer_food_list,
            employee_food_list,
            seasoning_list,
            daily_item_list,
            other_dept_food_list
        }).then((res: any) => {
            message.success('操作成功')
            window.history.go(-1)
        })
    }

    // 菜单目录：膳食中心->厨房管理->每日客餐订单->食材采购
    return (
        <div className="common-page">
            <BreadCrumb position={['膳食中心', '食材采购单申请']} />
            <div className="common-top-form">
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                    <h1 style={{fontSize: '28px', fontWeight: 'bold',marginBottom: '0'}}>{orderDetail.store_name}食材采购单申请</h1>
                    <Button type="default" style={{margin: '0 20px'}} onClick={() => { window.history.go(-1) }} >返回</Button>
                </div>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <div className="form-item">
                        <span style={{fontWeight: 'bold', fontSize: '20px'}}>客餐订单号：</span>
                        <span style={{fontSize: '20px', paddingRight: '15px'}}>{orderDetail.customer_order_code}</span>
                    </div>
                    <div className="form-item">
                        <span style={{fontWeight: 'bold', fontSize: '20px'}}>下单日期：</span>
                        <span style={{fontSize: '20px', paddingRight: '15px'}}>{orderDetail.customer_order_date}</span>
                    </div>
                </div>
            </div>
            {/* 食材采购内容 */}
            <div className="common-main">
                <div style={{marginBottom: '10px'}}>
                    <h1 style={{fontSize: '20px',marginBottom: '0', marginRight: '20px'}}>客餐食材</h1>
                    {/* 客餐食材 */}
                    <Table dataSource={customerFoodList} bordered={true} pagination={false} rowKey="index">
                        <Column title="物料编码" dataIndex="food_item_code" key="food_item_code" />
                        <Column title="物料" dataIndex="food_item_name" key="food_item_name" 
                            render={(text, record: any, index) => {
                                return (
                                    <>
                                        <Select
                                            virtual={false}
                                            showSearch
                                            placeholder="食材名称"
                                            value={record.food_item_id}
                                            onChange={(val) => {
                                                handleSelectFoodItem(1, val, index)
                                            }}
                                            style={{ width: 160,marginRight:12,marginBottom:12 }} 
                                            filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                                        >
                                            {
                                                foodItemList.map((el:any)=>(
                                                    <Option value={el.food_item_id } 
                                                        key={el.food_item_id}
                                                    >
                                                        {el.food_item_name}
                                                    </Option>
                                                )) 
                                            }   
                                        </Select>
                                    </>
                                )
                            }}
                        />
                        <Column title="客餐标准用量" dataIndex="use_dosage" key="use_dosage" 
                            render={(text, record:any) => {
                                const { use_dosage, use_unit, buy_dosage, buy_unit } = record
                                if(!use_dosage || use_dosage == 0) {
                                    return <></>
                                } else {
                                    return <>
                                        { `${use_dosage}${use_unit} = ${buy_dosage}${buy_unit}` }
                                    </>
                                }
                            }}
                        />
                        <Column title="食材份数" dataIndex="food_item_count" key="food_item_count" />
                        <Column title="客餐下单量" dataIndex="order_num" key="order_num"
                            render={(text, record: any, index:any) => {
                                return <>
                                    <InputNumber
                                        style={{width: '120px', marginRight: '10px'}}
                                        formatter={limitDecimals}
                                        value={record.order_num}
                                        min={0}
                                        onChange={(val: any) => {
                                            orderNumChange(1, index, val, 'order_num')
                                        }}
                                    />{record.order_unit}
                                </>
                            }}
                        />
                        <Column title="陪护餐下单量" dataIndex="escort_num" key="escort_num"
                            render={(text, record: any, index:any) => {
                                return <>
                                    <InputNumber
                                        style={{width: '120px', marginRight: '10px'}}
                                        formatter={limitDecimals}
                                        value={record.escort_num}
                                        min={0}
                                        onChange={(val: any) => {
                                            orderNumChange(1, index, val, 'escort_num')
                                        }}
                                    />{record.escort_unit}
                                </>
                            }}
                        />
                        <Column title="下单总量" dataIndex="total_num" key="total_num"
                            render={(text, record: any, index:any) => {
                                const { order_num, escort_num, total_unit } = record
                                let orderNum:any = order_num ? order_num : 0
                                let escortNum:any = escort_num ? escort_num : 0
                                let totalNum: any = Number(Number(orderNum) + Number(escortNum))
                                return <>
                                    {totalNum} {total_unit} 
                                </>
                            }}
                        />
                        <Column title="备注" dataIndex="remark" key="remark" 
                            render={(text, record: any, index:any) => {
                                return <>
                                    <Input
                                        value={record.remark}
                                        onChange={(val: any) => {
                                            orderRemarkChange(1, index, val, 'remark')
                                        }}
                                    />
                                </>
                            }}
                        />
                        {
                            customerFoodList.length > 1 && (
                                <Column render={(text, record: any, index:any) => {
                                    return <Button type="primary"
                                        onClick={() => { onDeledItem(1,index) }}
                                    >删除</Button>
                                }}/>
                            )
                        }
                    </Table>

                    <Button type="text" onClick={() => {
                        addCustomerFood(1)
                    }}>添加物料</Button>
                </div>

                <div style={{marginBottom: '10px'}}>
                    <h1 style={{fontSize: '20px',marginBottom: '0', marginRight: '20px'}}>员工餐食材</h1>
                    {/* 员工餐食材 */}
                    <Table dataSource={employeeFoodList} bordered={true} pagination={false} rowKey="index">
                        <Column title="物料编码" dataIndex="food_item_code" key="food_item_code" />
                        <Column title="物料" dataIndex="food_item_name" key="food_item_name" 
                            render={(text, record: any, index) => {
                                return (
                                    <>
                                        
                                        <Select
                                            virtual={false}
                                            showSearch
                                            placeholder="食材名称"
                                            value={record.food_item_id}
                                            onChange={(val) => {
                                                handleSelectFoodItem(2, val, index)
                                            }}
                                            style={{ width: 160,marginRight:12,marginBottom:12 }} 
                                            filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                                        >
                                            {
                                                foodItemList.map((el:any)=>(
                                                    <Option value={el.food_item_id } 
                                                        key={el.food_item_id}
                                                    >
                                                        {el.food_item_name}
                                                    </Option>
                                                )) 
                                            }   
                                        </Select>
                                    </>
                                )
                            }}
                        />
                        <Column title="员工餐下单量" dataIndex="order_num" key="order_num"
                            render={(text, record: any, index:any) => {
                                return <>
                                    <InputNumber
                                        style={{width: '120px', marginRight: '10px'}}
                                        formatter={limitDecimals}
                                        value={record.order_num}
                                        min={0}
                                        onChange={(val: any) => {
                                            orderNumChange(2, index, val, 'order_num')
                                        }}
                                    />{record.order_unit}
                                </>
                            }}
                        />
                        <Column title="下单总量" dataIndex="total_num" key="total_num"
                            render={(text, record: any, index:any) => {
                                const { order_num, total_unit } = record
                                let orderNum:any = order_num ? order_num : 0
                                return <>
                                    {Number(orderNum)} {total_unit} 
                                </>
                            }}
                        />
                        <Column title="备注" dataIndex="remark" key="remark" 
                            render={(text, record: any, index:any) => {
                                return <>
                                    <Input
                                        value={record.remark}
                                        onChange={(val: any) => {
                                            orderRemarkChange(2, index, val, 'remark')
                                        }}
                                    />
                                </>
                            }}
                        />
                        {
                            employeeFoodList.length > 1 && (
                                <Column render={(text, record: any, index:any) => {
                                    return <Button type="primary"
                                        onClick={() => { onDeledItem(2,index) }}
                                    >删除</Button>
                                }}/>
                            )
                        }
                    </Table>

                    <Button type="text" onClick={() => {
                        addCustomerFood(2)
                    }}>添加物料</Button>
                </div>

                <div style={{marginBottom: '10px'}}>
                    <h1 style={{fontSize: '20px',marginBottom: '0', marginRight: '20px'}}>调料品</h1>
                    {/* 调料品 */}
                    <Table dataSource={seasoningList} bordered={true} pagination={false} rowKey="index">
                        <Column title="物料编码" dataIndex="food_item_code" key="food_item_code" />
                        <Column title="物料" dataIndex="food_item_name" key="food_item_name" 
                            render={(text, record: any, index) => {
                                return (
                                    <>
                                        <Select
                                            virtual={false}
                                            showSearch
                                            placeholder="食材名称"
                                            value={record.food_item_id}
                                            onChange={(val) => {
                                                handleSelectFoodItem(3, val, index)
                                            }}
                                            style={{ width: 160,marginRight:12,marginBottom:12 }} 
                                            filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                                        >
                                            {
                                                foodItemList.map((el:any)=>(
                                                    <Option value={el.food_item_id } 
                                                        key={el.food_item_id}
                                                    >
                                                        {el.food_item_name}
                                                    </Option>
                                                )) 
                                            }   
                                        </Select>
                                    </>
                                )
                            }}
                        />
                        <Column title="下单量" dataIndex="order_num" key="order_num"
                            render={(text, record: any, index:any) => {
                                return <>
                                    <InputNumber
                                        style={{width: '120px', marginRight: '10px'}}
                                        formatter={limitDecimals}
                                        value={record.order_num}
                                        min={0}
                                        onChange={(val: any) => {
                                            orderNumChange(3, index, val, 'order_num')
                                        }}
                                    />{record.order_unit}
                                </>
                            }}
                        />
                        <Column title="下单总量" dataIndex="total_num" key="total_num"
                            render={(text, record: any, index:any) => {
                                const { order_num, total_unit } = record
                                let orderNum:any = order_num ? order_num : 0
                                return <>
                                    {Number(orderNum)} {total_unit} 
                                </>
                            }}
                        />
                        <Column title="备注" dataIndex="remark" key="remark" 
                            render={(text, record: any, index:any) => {
                                return <>
                                    <Input
                                        value={record.remark}
                                        onChange={(val: any) => {
                                            orderRemarkChange(3, index, val, 'remark')
                                        }}
                                    />
                                </>
                            }}
                        />
                        {
                            seasoningList.length > 1 && (
                                <Column render={(text, record: any, index:any) => {
                                    return <Button type="primary"
                                        onClick={() => { onDeledItem(3,index) }}
                                    >删除</Button>
                                }}/>
                            )
                        }
                    </Table>

                    <Button type="text" onClick={() => {
                        addCustomerFood(3)
                    }}>添加物料</Button>
                </div>

                <div style={{marginBottom: '10px'}}>
                    <h1 style={{fontSize: '20px',marginBottom: '0', marginRight: '20px'}}>日用品</h1>
                    {/* 日用品 */}
                    <Table dataSource={dailyItemList} bordered={true} pagination={false} rowKey="index">
                        <Column title="物料编码" dataIndex="food_item_code" key="food_item_code" />
                        <Column title="物料" dataIndex="food_item_name" key="food_item_name" 
                            render={(text, record: any, index) => {
                                return (
                                    <>
                                        <Select
                                            virtual={false}
                                            showSearch
                                            placeholder="食材名称"
                                            value={record.food_item_id}
                                            onChange={(val) => {
                                                handleSelectFoodItem(4, val, index)
                                            }}
                                            style={{ width: 160,marginRight:12,marginBottom:12 }} 
                                            filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                                        >
                                            {
                                                foodItemList.map((el:any)=>(
                                                    <Option value={el.food_item_id } 
                                                        key={el.food_item_id}
                                                    >
                                                        {el.food_item_name}
                                                    </Option>
                                                )) 
                                            }   
                                        </Select>
                                    </>
                                )
                            }}
                        />
                        <Column title="下单量" dataIndex="order_num" key="order_num"
                            render={(text, record: any, index:any) => {
                                return <>
                                    <InputNumber
                                        style={{width: '120px', marginRight: '10px'}}
                                        formatter={limitDecimals}
                                        value={record.order_num}
                                        min={0}
                                        onChange={(val: any) => {
                                            orderNumChange(4, index, val, 'order_num')
                                        }}
                                    />{record.order_unit}
                                </>
                            }}
                        />
                        <Column title="下单总量" dataIndex="total_num" key="total_num"
                            render={(text, record: any, index:any) => {
                                const { order_num, total_unit } = record
                                let orderNum:any = order_num ? order_num : 0
                                return <>
                                    {Number(orderNum)} {total_unit} 
                                </>
                            }}
                        />
                        <Column title="备注" dataIndex="remark" key="remark" 
                            render={(text, record: any, index:any) => {
                                return <>
                                    <Input
                                        value={record.remark}
                                        onChange={(val: any) => {
                                            orderRemarkChange(4, index, val, 'remark')
                                        }}
                                    />
                                </>
                            }}
                        />
                        {
                            dailyItemList.length > 1 && (
                                <Column render={(text, record: any, index:any) => {
                                    return <Button type="primary"
                                        onClick={() => { onDeledItem(4, index) }}
                                    >删除</Button>
                                }}/>
                            )
                        }
                    </Table>

                    <Button type="text" onClick={() => {
                        addCustomerFood(4)
                    }}>添加物料</Button>
                </div>

                <div style={{marginBottom: '10px'}}>
                    <h1 style={{fontSize: '20px',marginBottom: '0', marginRight: '20px'}}>其它部门食材</h1>
                    {/* 其它部门食材 */}
                    <Table dataSource={otherDeptFoodList} bordered={true} pagination={false} rowKey="index">
                        <Column title="物料编码" dataIndex="food_item_code" key="food_item_code" />
                        <Column title="物料" dataIndex="food_item_name" key="food_item_name" 
                            render={(text, record: any, index) => {
                                return (
                                    <>
                                        <Select
                                            virtual={false}
                                            showSearch
                                            placeholder="食材名称"
                                            value={record.food_item_id}
                                            onChange={(val) => {
                                                handleSelectFoodItem(5, val, index)
                                            }}
                                            style={{ width: 160,marginRight:12,marginBottom:12 }} 
                                            filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                                        >
                                            {
                                                foodItemList.map((el:any)=>(
                                                    <Option value={el.food_item_id } 
                                                        key={el.food_item_id}
                                                    >
                                                        {el.food_item_name}
                                                    </Option>
                                                )) 
                                            }   
                                        </Select>
                                    </>
                                )
                            }}
                        />
                        <Column title="下单量" dataIndex="order_num" key="order_num"
                            render={(text, record: any, index:any) => {
                                return <>
                                    <InputNumber
                                        style={{width: '120px', marginRight: '10px'}}
                                        formatter={limitDecimals}
                                        value={record.order_num}
                                        min={0}
                                        onChange={(val: any) => {
                                            orderNumChange(5, index, val, 'order_num')
                                        }}
                                    />{record.order_unit}
                                </>
                            }}
                        />
                        <Column title="下单总量" dataIndex="total_num" key="total_num"
                            render={(text, record: any, index:any) => {
                                const { order_num, total_unit } = record
                                let orderNum:any = order_num ? order_num : 0
                                return <>
                                    {Number(orderNum)} {total_unit} 
                                </>
                            }}
                        />
                        <Column title="备注" dataIndex="remark" key="remark" 
                            render={(text, record: any, index:any) => {
                                return <>
                                    <Input
                                        value={record.remark}
                                        onChange={(val: any) => {
                                            orderRemarkChange(5, index, val, 'remark')
                                        }}
                                    />
                                </>
                            }}
                        />
                        {
                            otherDeptFoodList.length > 1 && (
                                <Column render={(text, record: any, index:any) => {
                                    return <Button type="primary"
                                        onClick={() => { onDeledItem(5, index) }}
                                    >删除</Button>
                                }}/>
                            )
                        }
                    </Table>

                    <Button type="text" onClick={() => {
                        addCustomerFood(5)
                    }}>添加物料</Button>
                </div>
            </div>
            
            <div style={{textAlign: 'center', padding: '10px 0'}}>
                <Button type="default" style={{width: '200px', height: '45px', margin: '0 10px'}} onClick={() => { window.history.go(-1) }}>关闭</Button>
                <Button type="primary" style={{width: '200px', height: '45px', margin: '0 10px'}} onClick={() => { onSave() }}>提交</Button>
            </div>
        </div>
    )
}